<template>
  <v-row align="center" justify="center">
    <v-col cols="1" class="text-left" v-if="showAddButton">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" tile large color="primary" icon @click="reset()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("Clear") }}</span>
      </v-tooltip>
    </v-col>
    <v-col>
      <v-autocomplete
        v-model="conditionItem.fieldCode"
        :items="fieldList"
        item-text="DisplayText"
        item-value="Code"
        :label="$t('Field')"
        :disabled="disableFieldSelect"
        :error-messages="fieldCodeErrors"
        @change="fieldCodeChange"
      ></v-autocomplete>
    </v-col>
    <v-col v-if="showSearchOperatorSelect">
      <v-select
        v-model="conditionItem.searchOperatorCode"
        :items="filteredSearchOperators"
        :label="$t('Operator')"
        item-text="Title"
        item-value="Code"
        :disabled="disableSearchOperatorSelect"
        :error-messages="searchOperatorCodeErrors"
      ></v-select>
    </v-col>
    <v-col v-if="showValueField">
      <v-text-field
        v-model="conditionItem.fieldDisplayValue"
        v-if="fieldType == 0"
        :label="$t('Value')"
        :error-messages="fieldValueErrors"
      ></v-text-field>
      <v-text-field
        type="number"
        v-model="fieldValueNumeric"
        v-if="fieldType == 2"
        :label="$t('Value')"
        :error-messages="fieldValueErrors"
      ></v-text-field>
      <v-autocomplete
        :items="filteredListElements"
        item-text="text"
        item-value="text"
        :search-input.sync="search"
        :loading="isLoading"
        v-model="pivotAutoCompleteFieldValue"
        :multiple="multiValue"
        v-if="fieldType >= 3"
        :label="$t('Value')"
        :error-messages="fieldValueErrors"
        @change="multivalueToString"
      ></v-autocomplete>
      <BaseDatePicker
        v-if="fieldType == 1"
        :label="$t('Value')"
        :error-messages="fieldValueErrors"
        v-model="conditionItem.fieldDisplayValue"
      />
    </v-col>
    <v-col
      v-if="
        (fieldType == 0 || fieldType >= 4) &&
        !isEmptyNotEmptyOperator &&
        showMyself &&
        !conditionItem.isParameterizable
      "
    >
      <v-checkbox
        v-model="conditionItem.useMyself"
        :label="$t('Myself')"
      ></v-checkbox>
    </v-col>
    <v-col
      cols="1"
      v-if="
        fieldType == 1 && !isEmptyNotEmptyOperator && conditionItem.useToday
      "
    >
      <v-text-field
        type="number"
        v-model="conditionItem.daysBeforeAfterToday"
      ></v-text-field>
    </v-col>
    <v-col
      cols="3"
      v-if="
        fieldType == 1 && !isEmptyNotEmptyOperator && conditionItem.useToday
      "
    >
      <v-radio-group v-model="conditionItem.beforeAfter" row>
        <v-radio v-bind:label="$t('DaysBeforeToday')" value="B"></v-radio>
        <v-radio v-bind:label="$t('DaysAfterToday')" value="A"></v-radio>
      </v-radio-group>
    </v-col>
    <v-col
      v-if="
        fieldType == 1 &&
        !isEmptyNotEmptyOperator &&
        showToday &&
        !conditionItem.isParameterizable
      "
    >
      <v-checkbox
        v-model="conditionItem.useToday"
        :label="$t('Today')"
      ></v-checkbox>
    </v-col>
    <v-col v-if="showParameterizableValue">
      <v-switch
        v-model="conditionItem.isParameterizable"
        :label="$t('Parameterizable')"
      ></v-switch>
    </v-col>
    <v-col cols="1" align-self="center" class="text-right" v-if="showAddButton">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="ml-5 mb-3"
            tile
            large
            color="primary"
            icon
            @click="onConditionItemAdd()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("Add") }}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
import ContentTypeService from "@/services/ContentTypeService";
import Utils from "@/ecm/common/Utils";
import ConditionItem from "@/ecm/models/search/ConditionItem";
import FieldType from "@/ecm/variables/FieldType";
import StandardFieldCode from "@/ecm/variables/StandardFieldCode";
import SearchConstValues from "@/ecm/variables/SearchConstValues";
import { required, requiredIf } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  name: "SearchCriteriaCondition",
  props: {
    fieldList: {
      type: Array,
      default: () => [],
    },
    disableFieldSelect: {
      type: Boolean,
      default: false,
    },
    disableSearchOperatorSelect: {
      type: Boolean,
      default: false,
    },
    showSearchOperatorSelect: {
      type: Boolean,
      default: true,
    },
    showParameterizableValue: {
      type: Boolean,
      default: false,
    },
    showMyself: {
      type: Boolean,
      default: true,
    },
    showToday: {
      type: Boolean,
      default: true,
    },
    showAddButton: {
      type: Boolean,
      default: true,
    },
    conditionItem: {
      type: Object,
      default: () => new ConditionItem(),
    },
    clearValue: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.getListElements();
    this.$v.$reset();
  },
  data() {
    return {
      isLoading: false,
      search: null,
      pivotAutoCompleteFieldValue: null,
      listElements: [],
      filteredListElements: [],
      emptyNotEmptyOperatorCodes: [
        "s06",
        "s07",
        "d07",
        "d08",
        "n07",
        "n08",
        "l03",
        "l04",
      ],
    };
  },
  // if (
  //       this.conditionItem.fieldCode == "" ||
  //       this.conditionItem.searchOperatorCode == "" ||
  //       (this.conditionItem.fieldValue == "" && !this.isEmptyNotEmptyOperator)
  //     )
  mixins: [validationMixin],
  validations: {
    conditionItem: {
      fieldCode: { required },
      searchOperatorCode: {
        required: requiredIf(function () {
          return this.showSearchOperatorSelect;
        }),
      },
      fieldValue: {
        required: requiredIf(function () {
          return !this.isEmptyNotEmptyOperator;
        }),
      },
    },
  },
  computed: {
    fieldCodeErrors() {
      const errors = [];
      if (!this.$v.conditionItem.fieldCode.$dirty) return errors;
      !this.$v.conditionItem.fieldCode.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    searchOperatorCodeErrors() {
      const errors = [];
      if (!this.$v.conditionItem.searchOperatorCode.$dirty) return errors;
      !this.$v.conditionItem.searchOperatorCode.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    fieldValueErrors() {
      const errors = [];
      if (!this.$v.conditionItem.fieldValue.$dirty) return errors;
      !this.$v.conditionItem.fieldValue.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    propsToWatch() {
      return (
        this.conditionItem.fieldDisplayValue +
        this.conditionItem.useMyself +
        this.conditionItem.useToday +
        this.conditionItem.daysBeforeAfterToday +
        this.conditionItem.beforeAfter
      );
    },
    selectedFieldCode() {
      return this.conditionItem.fieldCode;
    },
    filteredSearchOperators() {
      if (this.fieldType !== "") {
        var allsearchOperators = this.$store.getters["account/searchOperators"];
        if (this.conditionItem.fieldCode == StandardFieldCode.Fulltext) {
          return allsearchOperators.filter((f) => f.Code == "f01");
        }
        if (
          this.conditionItem.fieldCode == StandardFieldCode.CreationDate ||
          this.conditionItem.fieldCode == StandardFieldCode.Author ||
          this.conditionItem.fieldCode == StandardFieldCode.DocumentId
        ) {
          return allsearchOperators.filter(
            (f) =>
              Utils.text.contains(f.FieldTypes, this.fieldType) &&
              f.Code != "s06" &&
              f.Code != "s07" &&
              f.Code != "d07" &&
              f.Code != "d08" &&
              f.Code != "n07" &&
              f.Code != "n08"
          );
        }
        return allsearchOperators.filter((f) =>
          Utils.text.contains(f.FieldTypes, this.fieldType)
        );
      } else return [];
    },
    isEmptyNotEmptyOperator() {
      if (this.conditionItem.searchOperatorCode == "") {
        return false;
      }
      return Utils.text.contains(
        this.emptyNotEmptyOperatorCodes,
        this.conditionItem.searchOperatorCode
      );
    },
    fieldValueNumeric: {
      // getter
      get: function () {
        var userDecSep = this.$store.getters["account/user"].MetricDecimalSep;
        var userThouSep = this.$store.getters["account/user"].MetricThousandSep;
        return this.conditionItem.fieldDisplayValue
          .replaceAll(userThouSep, "")
          .replaceAll(userDecSep, ".");
      },
      // setter
      set: function (newValue) {
        var userDecSep = this.$store.getters["account/user"].MetricDecimalSep;
        this.conditionItem.fieldDisplayValue = newValue.replaceAll(
          ".",
          userDecSep
        );
      },
    },
    showValueField() {
      if (
        this.isEmptyNotEmptyOperator ||
        this.conditionItem.isParameterizable
      ) {
        return false;
      }
      if (this.conditionItem.fieldType == FieldType.StaticList) {
        return true;
      }
      if (
        this.conditionItem.fieldType == FieldType.DateTime &&
        this.conditionItem.useToday
      ) {
        return false;
      }
      if (
        this.conditionItem.fieldType != FieldType.DateTime &&
        this.conditionItem.useMyself
      ) {
        return false;
      }
      return true;
    },
    fieldType() {
      if (this.conditionItem.fieldCode != "") {
        var field = this.fieldList.find(
          (x) => x.Code === this.conditionItem.fieldCode
        );
        if (field) {
          this.conditionItem.fieldType = field.Type;
        }
      }
      return this.conditionItem.fieldType;
    },
    multiValue() {
      if (this.conditionItem.fieldCode != "") {
        var field = this.fieldList.find(
          (x) => x.Code === this.conditionItem.fieldCode
        );
        if (field) {
          this.conditionItem.multiValue = field.Multivalue;
        }
      }
      return this.conditionItem.multiValue;
    },
  },
  watch: {
    search(val) {
      val !== this.conditionItem.fieldValue && this.filterListElements(val);
    },
    selectedFieldCode() {
      this.getListElements();
    },
    propsToWatch() {
      this.setFieldValue();
    },
    fieldList(val) {
      if (!val.some((x) => x.Code === this.conditionItem.fieldCode)) {
        this.conditionItem = new ConditionItem();
      }
    },
  },
  methods: {
    multivalueToString() {
      if (this.conditionItem.multiValue) {
        this.conditionItem.fieldDisplayValue =
          this.pivotAutoCompleteFieldValue.join(",");
      } else {
        this.conditionItem.fieldDisplayValue = this.pivotAutoCompleteFieldValue;
      }
    },
    multiValueToArray() {
      if (this.conditionItem.multiValue) {
        this.pivotAutoCompleteFieldValue = this.conditionItem.fieldDisplayValue
          .split(",")
          .filter((x) => x);
      } else {
        this.pivotAutoCompleteFieldValue = this.conditionItem.fieldDisplayValue;
      }
    },
    fieldCodeChange() {
      this.conditionItem.searchOperatorCode = null;
      this.conditionItem.useMyself = false;
      this.$v.$reset();
    },
    getListElements() {
      if (this.clearValue) {
        this.conditionItem.fieldValue = "";
        this.conditionItem.fieldDisplayValue = "";
      }
      if (this.conditionItem.fieldCode != "") {
        if (this.fieldType == FieldType.StaticList) {
          this.listElements = this.fieldList.find(
            (x) => x.Code === this.conditionItem.fieldCode
          ).ListElements;
          this.filterListElements();
          this.multiValueToArray()
        } else if (
          this.fieldType == FieldType.DynamicList ||
          this.fieldType == FieldType.DynamicTableList
        ) {
          this.isLoading = true;
          ContentTypeService.getListElements(this.conditionItem.fieldCode)
            .then((result) => {
              this.listElements = result;
              this.filterListElements();
              this.multiValueToArray()
            })
            .finally((x) => (this.isLoading = false));
        }
       
      }
    },
    filterListElements(search) {
      this.filteredListElements = (
        search
          ? this.listElements.filter((e) =>
              (e.text || "").toLowerCase().includes(search.toLowerCase())
            )
          : this.listElements
      ).slice(0, 1000);
    },
    setFieldValue() {
      this.conditionItem.fieldValue = this.conditionItem.fieldDisplayValue;
      if (this.isEmptyNotEmptyOperator) {
        this.conditionItem.fieldValue = SearchConstValues.Empty;
      } else {
        switch (this.conditionItem.fieldType) {
          case FieldType.DateTime:
            if (this.conditionItem.useToday) {
              if (
                this.conditionItem.daysBeforeAfterToday != "" &&
                this.conditionItem.daysBeforeAfterToday > 0
              ) {
                this.conditionItem.fieldValue = `${
                  this.conditionItem.daysBeforeAfterToday
                } ${
                  this.conditionItem.beforeAfter == "B"
                    ? SearchConstValues.DaysBeforeToday
                    : SearchConstValues.DaysAfterToday
                }`;
              } else this.conditionItem.fieldValue = SearchConstValues.Today;
            }
            break;
          case FieldType.String:
          case FieldType.DynamicList:
          case FieldType.DynamicTableList:
            if (this.conditionItem.useMyself) {
              this.conditionItem.fieldValue = SearchConstValues.Myself;
            }
            break;
        }
      }
      return this.conditionItem.fieldValue;
    },
    reset() {
      this.$emit("on-condition-item-remove", this.conditionItem);
      this.conditionItem = new ConditionItem();
      this.$v.$reset();
    },
    onConditionItemAdd() {
      if (!this.showSearchOperatorSelect) {
        this.$emit("on-condition-item-add");
        return;
      }

      this.setFieldValue();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      var item = new ConditionItem(this.conditionItem.conditionStr());
      item.fieldType = this.fieldType;
      this.$emit("on-condition-item-add", item);
    },
  },
};
</script>
